export default __webpack_public_path__ + "static/media/light_fallback.a6802e65.jpg";